export const notificationQueryKeys = {
  all: ['notifications'] as const,
  pulse: () => [...notificationQueryKeys.all, 'pulse'] as const,
  list: () => [...notificationQueryKeys.all, 'list'] as const,
}
